import { invoiceFormInitial } from "../../store/InitialStore";
import * as types from "../../actions/ActionTypes";
import moment from "moment";
import shortid from "shortid";

function commonCalculation(
  lineItemsArray = [],
  discountPercentage = 0,
  taxPercentage = 0
) {
  const subTotal = lineItemsArray.reduce(
    (a, b) => a + (b["totalAmount"] || 0),
    0
  );
  const discountAmount =
    (parseFloat(discountPercentage) / 100) * parseFloat(subTotal);
  const taxAmount =
    (parseFloat(taxPercentage || 0) / 100) * parseFloat(subTotal);
  const grandTotalAmount =
    parseFloat(subTotal) + parseFloat(taxAmount) - parseFloat(discountAmount);
  return {
    subTotal,
    discountAmount,
    taxAmount,
    grandTotalAmount,
  };
}

export default function InvoiceFormReducer(state = invoiceFormInitial, action) {
  const { type, payload, uniqueId, field, name } = action;
  const { lineItems = [], taxPercentage = 0, discountPercentage = 0 } = state;

  switch (type) {
    //Add Line Item
    case types.INVOICE_ADD_LINE_ITEM:
      lineItems.push({
        uniqueId: shortid.generate(),
        invoiceItemId: 0,
        itemDescription: "",
        quantity: "",
        individualAmount: "",
        totalAmount: 0,
        isDeleted: false,
      });
      return {
        ...state,
        lineItems,
      };

    //Change Field Values
    case types.INVOICE_LINE_ITEM_VALUES:
      //First Update Field Value
      lineItems.find((record) => record.uniqueId === uniqueId)[field] = payload;
      //Calculate Amount
      lineItems.forEach((element) => {
        element.totalAmount = element.quantity * element.individualAmount;
        return element;
      });
      const returndata = commonCalculation(
        lineItems,
        discountPercentage,
        taxPercentage
      );
      return {
        ...state,
        lineItems,
        subTotal: returndata.subTotal,
        tax: returndata.taxAmount,
        discount: returndata.discountAmount,
        grandTotalAmount: returndata.grandTotalAmount,
      };

    //Remove Line Item
    case types.INVOICE_DELETE_LINE_ITEM:
      const filteredItems = lineItems.filter(
        ({ uniqueId }) => uniqueId !== payload
      );
      const returndata1 = commonCalculation(
        filteredItems,
        discountPercentage,
        taxPercentage
      );
      return {
        ...state,
        lineItems: filteredItems,
        subTotal: returndata1.subTotal,
        discount: returndata1.discountAmount,
        tax: returndata1.taxAmount,
        grandTotalAmount: returndata1.grandTotalAmount,
      };

    //Change Form Base Field Values
    case types.INVOICE_UPDATE_FORM_BASE_VALUES:
      let currenttax = taxPercentage,
        currentDiscount = discountPercentage;
      if (field === "taxPercentage") {
        currenttax = payload;
      } else if (field === "discountPercentage") {
        currentDiscount = payload;
      }

      const returndata2 = commonCalculation(
        lineItems,
        currentDiscount,
        currenttax
      );
      return {
        ...state,
        lineItems,
        subTotal: returndata2.subTotal,
        discount: returndata2.discountAmount,
        tax: returndata2.taxAmount,
        grandTotalAmount: returndata2.grandTotalAmount,
        [field]: payload,
      };

    //Save All Line Items Values
    case types.SAVE_INVOICE_FORM_REDUCER:
      const {
        invoiceItems = [],
        memo = "",
        paymentLinkExpiryDay = "",
        invoiceExpiryDate = "",
        taxPercentage: taxValue = 0,
        couponId = 0,
        couponDiscountPercentage = 0,
        subscriptionid = 0,
        locationCode = "",
      } = payload;
      //adding unique id
      let arrayItem = JSON.parse(invoiceItems).map((data) => {
        const {
          invoiceItemId = 0,
          itemDescription = "",
          quantity = "",
          individualAmount = 0,
          totalAmount = 0,
          isDeleted = false,
        } = data;
        return {
          uniqueId: shortid.generate(),
          invoiceItemId,
          itemDescription,
          quantity,
          individualAmount,
          totalAmount,
          isDeleted,
        };
      });

      const retrunAPIdata = commonCalculation(
        arrayItem,
        couponDiscountPercentage,
        taxValue
      );

      return {
        ...state,
        memo,
        lineItems: arrayItem,
        couponId,
        invoiceExpiryDate: new Date(invoiceExpiryDate),
        taxPercentage: parseFloat(taxValue),
        discountPercentage: parseFloat(couponDiscountPercentage),
        paymentExpiryDate: paymentLinkExpiryDay,
        subTotal: retrunAPIdata.subTotal,
        discount: retrunAPIdata.discountAmount,
        tax: retrunAPIdata.taxAmount,
        grandTotalAmount: parseFloat(retrunAPIdata.grandTotalAmount),
        subscriptionid: subscriptionid,
        locationCode,
      };

    case types.RESET_INVOICE_FORM_REDUCER:
      return {
        ...state,
        couponId: 0,
        lineItems: [
          {
            uniqueId: shortid.generate(),
            invoiceItemId: 0,
            itemDescription: "",
            quantity: "",
            individualAmount: "",
            totalAmount: 0,
            isDeleted: false,
          },
        ],
        tax: 0,
        taxPercentage: 0,
        discount: 0,
        discountPercentage: 0,
        subTotal: 0,
        grandTotalAmount: 0,
        invoiceExpiryDate: "",
        paymentExpiryDate: "",
        memo: "",
        subscriptionid: "",
        locationCode: "",
      };

    default:
      return state;
  }
}
